import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { emitEvent } from '@/utils/eventBus';
const base = `${import.meta.env.VITE_STRAPI_URL ?? 'http://localhost:1337'}/api/supplier-payments`;
export const paymentRequest = async (
  path = '',
  { method = 'get', data, params } = {},
) => {
  const auth = useAuthStore();
  try {
    const response = await axios({
      url: `${base}${path}`,
      method,
      data,
      params,
      headers: auth.token ? auth.requestHeaders.headers : {},
    });
    if (
      method !== 'get' &&
      !['/preview', '/snapshots', '/invoice-links'].includes(path)
    )
      emitEvent('supplier-payments:changed');
    return response.data;
  } catch (error) {
    error.message = error.response?.data?.error?.message || error.message;
    throw error;
  }
};
export const fetchPaymentSnapshots = async (appointments) => {
  const ids = appointments.map((item) => String(item.documentId || item.id));
  const lines = [];
  for (let i = 0; i < ids.length; i += 500) {
    const result = await paymentRequest('/snapshots', {
      method: 'post',
      data: { ids: ids.slice(i, i + 500) },
    });
    lines.push(...(result.data || []));
  }
  return new Map(lines.map((line) => [line.appointmentId, line]));
};
